import './SingleCard.css'

export default function FloorCard({ card, handleFloorSelection }) {
	const handleClick = () => {
		if (!card.disabled && !card.locked) {
			handleFloorSelection(card)
		}
	}

	return (
		<div className={card.disabled ? 'card disabled' : 'card'}>
			<div className={card.flipped ? 'flipped' : ''}>
				<img className='front' src={card.src} alt='card front' />
				<img
					className={card.locked ? 'back locked' : 'back'}
					src='./assets/card_back_2.png'
					alt='card back'
					onClick={handleClick}
				/>
			</div>
		</div>
	)
}
